import React, { Component } from "react";
import styled from "styled-components";
import Moment from 'moment';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import EmployeeService from '../../../services/Employee.service'

import TilesArea from './TilesArea'
import Tile from '../../Tile'

const VestTile = styled.li`
    > div.tile > div.button {
        width: 106px;
    }
`

class VestsArea extends Component {

    onVestClicked = (vest) => {
        if(this.props.onVestClicked) {
            this.props.onVestClicked(vest)
        }
    }

    calculateTaxBadge = (t, vest) => {
        if(vest && vest.fed_override_tax !== this.props.default_tax_rate && vest.fed_override_tax) {
            return t('StockAwards.VestsSection.FederaltaxBadge', {percent: new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(vest.fed_override_tax)})
        }
        return null
    }

    getVestQtyLabel = (vest) => {
      return vest.vested ? 'StockAwards.VestsSection.SharesVested' : 'StockAwards.VestsSection.SharesToVest'
    }

    getFooter = (trans_or_vest) => {
        var broker = this.props.broker ? this.props.broker : EmployeeService.getBrokersDisplayFromVest(this.props.t, this.props.awards, trans_or_vest)
        return broker
    }

    getBrokers = (trans_or_vest) => {
        if (this.props.broker) {
            return [this.props.broker]
        }
        else {
            return EmployeeService.getBrokersFromVest(this.props.t, this.props.awards, trans_or_vest)
        }
    }

    getFooterTopTrans = (t, isRSU, transaction) => {
        if (isRSU){
            return t('StockAwards.VestsSection.SharesDeposited', {qty: transaction.net_shares === -1 ? '-' : transaction.net_shares})
        }
        else {
            return t('StockAwards.VestsSection.NetProceeds', {amount: transaction.net_proceeds === -1 ? '-' : new Intl.NumberFormat(this.props.locale, { style: 'currency', currency: 'USD' }).format(transaction.net_proceeds)})
        }
    }

    getFractionalElection = (vest) => {
        if (this.props.fractional_mode && EmployeeService.hasFractionalEligibleVest(this.props.employee)){
            return " (" + EmployeeService.getVestFractionalElectionText(this.props.t, this.props.employee, vest) + ")"
        }
        else{
            return ""
        }
    }

    render() {
        const count = this.props.vests ? this.props.vests.length : this.props.transactions.length
        const {vests, transactions, t, isRSU} = this.props
        const hideLinkLabel = t('StockAwards.VestsSection.HideLinkLabel')
        const showLinkLabel = t('StockAwards.VestsSection.ShowLinkLabel')
        const hideLinkMobileLabel = t('StockAwards.VestsSection.HideLinkMobileLabel')
        const showLinkMobileLabel = t('StockAwards.VestsSection.ShowLinkMobileLabel')

        return (
            <TilesArea title={`${this.props.title} (${count})`}
                areaId={this.props.areaId}
                hideLinkLabel={hideLinkLabel}
                showLinkLabel={showLinkLabel}
                hideLinkMobileLabel={hideLinkMobileLabel}
                showLinkMobileLabel={showLinkMobileLabel}>

                {transactions && transactions.map((transaction, i) =>
                    <VestTile key={`transaction_${transaction.id}`}>
                        <Tile
                        date={Moment(transaction.transaction_date).format('LL')}
                        info={isRSU ? t('StockAwards.VestsSection.SharesTransacted', {qty: transaction.shares_transacted, award_type: isRSU ? 'RSUs' : 'Options'}) :
                        t('StockAwards.VestsSection.SharesExercised', {qty: transaction.shares_transacted})}
                        footerTop={this.getFooterTopTrans(t, isRSU, transaction)}
                        footerMid={transaction.broker.name ? transaction.broker.name: ''}
                        footerBottom={this.props.footerBottom ? this.props.footerBottom : this.getBrokers(transaction)[1]}
                        footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
                        footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
                        footer={this.getFooter(transaction)}
                        headerButtonLabel={this.calculateTaxBadge(t, null)}
                        isClickable="true"
                        obj={transaction}
                        onTileClicked={this.onVestClicked}
                        theme="default"/>
                    </VestTile>
                )}

                {vests && vests.map((vest, i) =>
                    <VestTile key={`vest_${vest.id}`}>
                        <Tile
                        date={Moment(vest.vest_date).format('LL')}
                        info={t(this.getVestQtyLabel(vest), {qty: vest.vest_shares, award_type: isRSU ? 'RSUs' : 'Options'})}
                        footerTop={t("TaxTreatment." + vest.tax_election.code) + this.getFractionalElection(vest) }
                        footerMid={this.props.footerMid ? this.props.footerMid : this.getBrokers(vest)[0]}
                        footerBottom={this.props.footerBottom ? this.props.footerBottom : this.getBrokers(vest)[1]}
                        footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
                        footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
                        footer={this.getFooter(vest)}
                        headerButtonLabel={this.calculateTaxBadge(t, vest)}
                        isClickable="true"
                        obj={vest}
                        onTileClicked={this.onVestClicked}
                        theme="default"/>
                    </VestTile>
                )}


            </TilesArea>
        );
    }
}

const mapState = state => ({
    default_tax_rate: state.configuration.default_tax_rate,
    fractional_mode: state.static_content.fractional_mode,
    employee: state.employee
});

export default connect(mapState)(withTranslation("translations")(VestsArea));

